import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import StandardSection from './standard_section';
import AdditionalSection from './additional_section';

const SurveyBuilderView = ({ template }) => {
  const questionTemplates = template.get('surveyQuestions').map((q) => q.getIn(['surveyQuestion', 'questionTemplate']));
  const standardQuestionChoices = questionTemplates.filter((qt) => !qt.getIn(['extra', 'additionalScreeningQuestion']));
  const additionalQuestionChoices = questionTemplates.filter((qt) => qt.getIn(['extra', 'additionalScreeningQuestion']));

  return (
    <div>
      <StandardSection choices={standardQuestionChoices} />
      <AdditionalSection choices={additionalQuestionChoices} />
    </div>
  );
};
SurveyBuilderView.propTypes = {
  template: PropTypes.instanceOf(Map).isRequired,
};

export default SurveyBuilderView;
